import React from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { ReduxState } from "../../../../redux";
import { setCanvasMode } from "../../../../redux/reducers/TemplateField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {};

export const CanvasModeBanner: React.SFC<Props> = () => {
  const { canvasMode, selectedEdge } = useSelector(
    (state: ReduxState) => state.TemplateField
  );
  const dispatch = useDispatch();

  if (canvasMode === "selectWords") {
    let msg = "";
    switch (canvasMode) {
      case "selectWords":
        msg = `Click and drag to draw a box around the words that mark the ${
          selectedEdge || ""
        } edge`;
        break;
    }
    return (
      <div className="canvas-mode-banner text-center">
        <Alert style={{ marginBottom: 0 }} variant="info">
          <FontAwesomeIcon icon="exclamation-triangle" />
          <span className="ml-2">{msg}</span>
        </Alert>
      </div>
    );
  } else if (["edges", "tableColumns"].includes(canvasMode)) {
    return (
      <div className="canvas-mode-banner text-center">
        <Alert style={{ marginBottom: 0 }} variant="info">
          <FontAwesomeIcon icon="exclamation-circle" />
          <Button
            onClick={() =>
              dispatch(setCanvasMode({ canvasMode: "rectangles" }))
            }
          >
            Done
          </Button>
        </Alert>
      </div>
    );
  }
  return null;
};
